module.exports = __webpack_public_path__ + "2553fed28cb202077f0242a2883a52d8.png";